<template lang="pug">
  v-select(
    v-model="p_code"
    :items="masterList"
    item-text="label"
    :item-value="itemValue"
    :label="labelDisp"
    :small-chips="useFilter"
    :multiple="useFilter"
    :clearable="clearable"
    :box="readonly"
    :readonly="readonly"
    :error-messages="errorHandlerMethod(errorHandlerMethodArgComputed)")
</template>

<script>
import * as Enum from "@/assets/js/enum";
export default {
  props: {
    // TODO:type:String 必須でありながらNullがはいる可能性があるため回避。（※clearable）
    // eslint-disable-next-line vue/require-prop-types
    code: {
      required: true
    },
    errorHandlerMethod: {
      type: Function,
      default() {
        return null;
      }
    },
    errorHandlerMethodArg: {
      type: String,
      default() {
        return null;
      }
    },
    useFilter: {
      type: Boolean,
      default() {
        return false;
      }
    },
    readonly: {
      type: Boolean,
      default() {
        return false;
      }
    },
    labelDisp: {
      type: String,
      default: "FAX送信対象"
    },
    clearable: {
      type: Boolean,
      default() {
        return false;
      }
    },
    filterUnset: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      defaultErrorHandlerMethodArg: "faxTarget"
    };
  },
  computed: {
    p_code: {
      get() {
        return this.code;
      },
      set(newVal) {
        if (this.code !== newVal) this.$emit("update:code", newVal);
      },
      required: true
    },
    masterList: {
      get() {
        if (this.filterUnset) {
          return Enum.Utils.enumToList(Enum.FaxTargetFlag).filter(
            value => value.code !== Enum.FaxTargetFlag.Unset.code
          );
        } else {
          return Enum.Utils.enumToList(Enum.FaxTargetFlag);
        }
      }
    },
    errorHandlerMethodArgComputed: {
      get() {
        if (this.errorHandlerMethodArg == null) {
          return this.defaultErrorHandlerMethodArg;
        }
        return this.errorHandlerMethodArg;
      }
    },
    itemValue: {
      get() {
        if (this.useFilter) {
          return "label";
        } else {
          return "code";
        }
      }
    }
  },
  methods: {}
};
</script>
